import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as api from 'api/methods';

import { COURSE_STRUCTURES, LESSON_TYPES } from 'constants/common';

import { currentCourseSelector } from 'store/course/selectors';

import { showToast } from 'helpers/showToast';

import { useFetch } from 'hooks/useFetch';

import {
  convertTheoryLessonToApi,
  convertFigmaLessonToApi,
  getLessonById,
} from './CopySettings.helpers';

import CopySettings from './CopySettings';

const CopySettingsContainer = ({ onClose, lessonId, ...restProps }) => {
  const currentCourse = useSelector(currentCourseSelector);

  const [copyLoading, setCopyLoading] = useState(false);
  const [currentModules, setCurrentModules] = useState([]);

  const { loading: loadingCourses, data: courses } = useFetch(
    {
      defaultData: [],
      fetcher: api.getCourses,
      immediately: true,
      stopRequest: false,
    },
    null,
    [],
  );

  const handleCourseChanged = async (courseOption) => {
    const nextCourse = courses.find(
      (course) => course.id === courseOption.value,
    );

    if (nextCourse.structure === COURSE_STRUCTURES.MODULES) {
      const modules = await api.getCourseModules(nextCourse.id);

      setCurrentModules(modules);
    }
  };

  const handleCopyClick = async (values) => {
    const copyLesson = getLessonById(currentCourse, lessonId);

    debugger;

    if (!copyLesson) {
      console.warn('not lesson found'); // TODO

      return;
    }

    try {
      setCopyLoading(true);

      switch (copyLesson.type) {
        case LESSON_TYPES.THEORY_LESSON: {
          await api.createTheoryLesson(
            convertTheoryLessonToApi(
              copyLesson,
              values.course.value,
              values.module.value,
            ),
          );

          break;
        }
        case LESSON_TYPES.FIGMA_LESSON: {
          await api.createFigmaLesson(
            convertFigmaLessonToApi(
              copyLesson,
              values.course.value,
              values.module.value,
            ),
          );

          break;
        }
      }

      showToast({
        data: {
          variant: 'success',
          title: 'Copy lesson',
          text: 'Copy lesson is finished successfully',
        },
      });

      setCopyLoading(false);
    } catch (error) {
      console.warn(error);

      setCopyLoading(false);
    }

    // try {
    //   await dispatch(
    //     updateCourseById({ courseId, data: convertDataToApi(values) }),
    //   ).unwrap();
    //   showToast({
    //     data: {
    //       variant: 'success',
    //       title: getTranslation('common.toast.course_saved.title'),
    //       text: getTranslation('common.toast.course_saved.text'),
    //     },
    //   });
    //   onClose();
    // } catch (error) {
    //   showToast({
    //     variant: 'error',
    //     title: getTranslation('common.toast.error.title'),
    //     text: getTranslation('common.toast.error.text'),
    //   });
    // }
    // setSaveLoading(false);
  };

  const loading = loadingCourses;

  const coursesOptions = !loading
    ? courses.map((course) => ({ label: course.title, value: course.id }))
    : [];
  const modulesOptions = !loading
    ? currentModules.map((module) => ({
        label: module.title,
        value: module.id,
      }))
    : [];

  return (
    <CopySettings
      {...restProps}
      loading={loading}
      copyLoading={copyLoading}
      coursesOptions={coursesOptions}
      modulesOptions={modulesOptions}
      onClose={onClose}
      onCourseChanged={handleCourseChanged}
      onCopyClick={handleCopyClick}
    />
  );
};

export default React.memo(CopySettingsContainer);
